import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
  query AnswerTemplatesPagination($page: Int, $pageSize: Int) {
    answerTemplatesPagination(page: $page, pageSize: $pageSize) {
      answerTemplates {
        id
        text
        value
        markers{
          id
          name
          directory {
            id
            name
          }
        }
      }
      totalCount
      pageSize
    }
  }
`;

function getAnswerTemplatesPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.answerTemplatesPagination);
}

export default getAnswerTemplatesPagination;
